import { z } from 'zod'
import { AddressSchema, ContactPersonSchema } from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { TRANSIT_PARTY_NAME_MAX_LENGTH } from 'shared/ncts/common/constants'

export const TraderTargetEnum = z.enum([
  'CONSIGNEE',
  'CONSIGNOR',
  'CARRIER',
  'DECLARANT',
  'SELLER',
  'BUYER',
])

const TraderSchema = z.object({
  id: z.number().nullable(),
  deleted: z.boolean().optional(),
  target: TraderTargetEnum,
  name: z.string().max(TRANSIT_PARTY_NAME_MAX_LENGTH),
  identificationNumber: z.string(),
  address: AddressSchema.nullable(),
  contactPerson: ContactPersonSchema.nullable(),
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ConsignorSchema = TraderSchema
  .extend({
    typeOfPerson: z.string().optional(),
  })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  .superRefine((address, ctx) => {
  })

export const ConsigneeSchema = TraderSchema
  .extend({
    typeOfPerson: z.string().optional(),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }).superRefine((arg, ctx) => {
  })

export const CarrierSchema = TraderSchema
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  .superRefine((arg, ctx) => {
  })

export const DeclarantSchema = TraderSchema
  .omit({ contactPerson: true })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  .superRefine((arg, ctx) => {})

export const SellerSchema = TraderSchema
  .extend({
    typeOfPerson: z.string().optional(),
  })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  .superRefine((arg, ctx) => {})

export const BuyerSchema = TraderSchema
  .extend({
    typeOfPerson: z.string().optional(),
  })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  .superRefine((arg, ctx) => {})

export type ConsignorFormValues = z.infer<typeof ConsignorSchema>
export type ConsigneeFormValues = z.infer<typeof ConsigneeSchema>
export type CarrierFormValues = z.infer<typeof CarrierSchema>
export type Declarant = z.infer<typeof DeclarantSchema>
export type SellerFormValues = z.infer<typeof SellerSchema>
export type BuyerFormValues = z.infer<typeof BuyerSchema>

export type TraderType = ConsignorFormValues | ConsigneeFormValues | CarrierFormValues | Declarant | SellerFormValues | BuyerFormValues
export type TraderTargetType = z.infer<typeof TraderTargetEnum>
